export default "__VITE_ASSET__DRLiyGVq__"